<div class="row mx-0">
    <div class="col-md-6 head-top">
        <div class="send-money" >
            <h5 class="sm-18 color-blue font-weight-bold pb-3"> Transfer purpose</h5>
            <small class="custom-text-font-purpose sm-12 mobile16 color-royalblue">When sending money, we have to ask the reason for your transfer. Please select yours from below.</small>
            <div  class="md-6 sm-12 mt-2" >
                <form #purposeForm="ngForm" (ngSubmit)="onpurposeFormSubmit(purposeForm)">
                    <div class="form-group" *ngIf="auth.user.country_id==233">
                        <select class="form-control border-0 box-shadows" name="remittance_purpose" ngModel required>
                            <option value="" hidden> Select a reason </option>
                            <option value="Land Purchase"> Land purchase </option>
                            <option value="House Purchase"> House purchase </option>
                            <option value="House Building"> House building </option>
                            <option value="Loan Repayment"> Loan repayment </option>
                            <option value="Education Expense"> Education expense </option>
                            <option value="Medical Expenses"> Medical expenses </option>
                            <option value="Family Expenses"> Family expenses </option>
                            <option value="Savings Deposits"> Savings deposits </option>
                            <option value="Marriage Expenses"> Marriage expenses </option>
                            <option value="Travelling Expenses"> Travelling expenses </option>
                            <option value="Gifts"> Gifts </option>
                        </select>
                    </div>
                    <div class="form-group" *ngIf="auth.user.country_id==39">
                        <select class="form-control border-0" name="reason_code" [(ngModel)]="reason_code" required>
                            <option value="" hidden> Select a reason </option>
                            <option [value]="item.attributes.code" *ngFor="let item of sendMoneyService.caReasons"> {{item.attributes.reason}} </option>
                        </select>
                    </div>
                    <div *ngIf="auth.user.country_id==233">
                        <!-- <label for="description">Description</label>
                        <span style="color:red;">*</span> -->
                        <textarea class="form-control p-3 border-0 box-shadows" rows="8"  required name="note" ngModel
                        placeholder="Payment Description"></textarea>   
                    </div>
                    <div class="mt-4 d-flex justify-content-between address_field">
                        <button (click)="goBack()" type="button" class="btn  transparent-btn primary-text  back-btn">Back</button>
                        <button type="submit" [disabled]="!purposeForm.valid" class="btn px-5 primary-btn w-100">Next</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>